import { useState, type ReactNode } from "react";
import type { Route } from "../routing";
import { getTheme, setTheme, type Theme } from "../util/theme";
import {
  IconGauge, IconWrench, IconKey, IconChart, IconMessage, IconInbox, IconCar,
  IconSmartphone, IconLogout, IconSun, IconMoon,
} from "./icons";

const ITEMS: { route: Route; label: string; icon: ReactNode }[] = [
  { route: "overview", label: "Bosh sahifa", icon: <IconGauge /> },
  { route: "workshops", label: "Ustaxonalar", icon: <IconWrench /> },
  { route: "codes", label: "Aktivatsiya kodlari", icon: <IconKey /> },
  { route: "analytics", label: "Analitika", icon: <IconChart /> },
  { route: "tickets", label: "Murojaatlar", icon: <IconMessage /> },
  { route: "leads", label: "Leadlar", icon: <IconInbox /> },
  { route: "haydovchilar", label: "Haydovchilar", icon: <IconCar /> },
  // Oxirida — bu kundalik ish emas, oyiga bir marta ochiladi.
  { route: "app-version", label: "Ilova versiyasi", icon: <IconSmartphone /> },
];

export function Sidebar({
  current,
  userName,
  onNavigate,
  onLogout,
}: {
  current: Route;
  userName: string;
  onNavigate: (r: Route) => void;
  onLogout: () => void;
}) {
  const [theme, setThemeState] = useState<Theme>(getTheme());
  function toggleTheme() {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    setThemeState(next);
  }

  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark"><IconWrench width={16} height={16} /></span>
        <span className="brand-text">
          AvtoDaftar
          <span className="brand-sub">Platforma admin</span>
        </span>
      </div>
      <nav className="nav">
        {ITEMS.map((it) => {
          const active = current === it.route || (current === "workshop-detail" && it.route === "workshops");
          return (
            <button
              key={it.route}
              className={active ? "active" : ""}
              aria-current={active ? "page" : undefined}
              onClick={() => onNavigate(it.route)}
            >
              <span className="nav-ico">{it.icon}</span>
              {it.label}
            </button>
          );
        })}
      </nav>
      <div className="footer">
        <span className="who">{userName}</span>
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Yorug' rejim" : "Qorong'i rejim"}
          title={theme === "dark" ? "Yorug' rejim" : "Qorong'i rejim"}
        >
          {theme === "dark" ? <IconSun width={16} height={16} /> : <IconMoon width={16} height={16} />}
        </button>
      </div>
      <button className="logout" onClick={onLogout}>
        <IconLogout width={15} height={15} /> Chiqish
      </button>
    </aside>
  );
}
